import { createSelector } from 'reselect'
import path from 'ramda/es/path'
import identity from 'ramda/es/identity'

import { CAFETERIA_TYPE_GLOLIME, CAFETERIA_TYPE_ITEKO } from 'app/constants/apps/cafeteria'


export const selectIsCafeteriaEnabled = createSelector(
  [
    (state, id) => (path(['students', 'data', id, 'hasCafeteria'], state) || false),
  ],
  identity
)

export const selectIsGlolimeEnabled = createSelector(
  [
    (state, id) => (path(
      ['students', 'data', id, 'cafeteriaExternalServiceType'],
      state
    ) === CAFETERIA_TYPE_GLOLIME),
  ],
  identity
)

export const selectIsItekoEnabled = createSelector(
  [
    (state, id) => (path(
      ['students', 'data', id, 'cafeteriaExternalServiceType'],
      state
    ) === CAFETERIA_TYPE_ITEKO),
  ],
  identity
)
